import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0817df3c&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0817df3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817df3c",
  null
  
)

export default component.exports